import axios from 'axios';
import config from '../../../utils/config';

// The public /connect-azure page is opened by a client admin who isn't signed in to Synapse,
// so it must not use utils/request: that one asks MSAL for a token (opening a login popup)
// and its interceptor toasts and redirects on errors.
const publicClient = axios.create({
  baseURL: config.baseApi,
  headers: { Accept: 'application/json' },
});

class ConnectAzureService {
  public async resolveLink(token: string): Promise<string> {
    const res = await publicClient.get(
      `/azure-onboarding-callback/link/${encodeURIComponent(token)}`
    );
    return res.data.body.data.consent_url;
  }
}

export default new ConnectAzureService();
